module.exports = __webpack_public_path__ + "static/media/toggleMenuWhite.c1830766.svg";